import './footer.scss'
import logo from './logo.svg'

function Footer() {
    return(
        <footer className='footer'>
            <div className='footer__content'>
                <div className='company'>
                    <img src={logo} alt='logo'/>
                    <div className='company__description'>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam,
                        purus sit amet luctus venenatis, lectus magna fringilla urna,
                        porttitor rhoncus dolor purus non enim praesent elem
                    </div>
                </div>
                <div className='footer__menu'>
                    <div className='item item_bold'>Service</div>
                    <div className='item'>Domain</div>
                    <div className='item'>Shared Hosting</div>
                    <div className='item'>Private Hosting</div>
                    <div className='item'>Cloud Hosting</div>
                </div>
                <div className='footer__menu'>
                    <div className='item item_bold'>Hosting</div>
                    <div className='item'>Cheap Hosting</div>
                    <div className='item'>Hosting Wordpress</div>
                    <div className='item'>Email Hosting</div>
                    <div className='item'>Hosting Unlimited</div>
                </div>
                <div className='footer__menu'>
                    <div className='item item_bold'>Company</div>
                    <div className='item'>About</div>
                    <div className='item'>Career</div>
                    <div className='item'>Contact us</div>
                </div>
                <div className='footer__menu'>
                    <div className='item item_bold'>Help</div>
                    <div className='item'>FAQ</div>
                    <div className='item'>Help support</div>
                </div>
            </div>
            <div className='copyright'>
                Built by Jeremiah with ♥ in Lagos. Copyright 2021
            </div>
        </footer>
    )
}

export default Footer
